// eslint-disable-next-line max-classes-per-file
import { Base } from '@studiometa/js-toolkit';

/**
 *
 */
class NielsenAccordion extends HTMLElement {
  /**
   *
   */
  connectedCallback() {
    this.accordionContent = this.querySelector('nielsen-accordion-content');
    this.btn = this.querySelector('button');

    this.btn.addEventListener('click', this.onClick.bind(this));
  }

  /**
   * on click
   */
  onClick() {
    // eslint-disable-next-line no-unused-expressions
    this.accordionContent.getAttribute('aria-hidden') === 'false'
      ? this.accordionContent.setAttribute('aria-hidden', 'true')
      : this.accordionContent.setAttribute('aria-hidden', 'false');
    // eslint-disable-next-line no-unused-expressions
    this.btn.getAttribute('aria-expanded') === 'false'
      ? this.btn.setAttribute('aria-expanded', 'true')
      : this.btn.setAttribute('aria-expanded', 'false');
  }
}

/**
 * Accordion component
 */
export default class Accordion extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Accordion',
  };

  /**
   * mounted
   */
  mounted() {
    customElements.define('nielsen-accordion', NielsenAccordion);
  }
}
